export default {
  getCameraList: (state) => {
    return state.camera_list;
  },
  getCurrentPosition: (state) => {
    return state.current_pos;
  },
  getCurrentTime: (state) => {
    return state.current_time;
  },
  getMyWakes: (state) => {
    return state.my_wakes;
  },
  getStartTime: (state) => {
    return state.start_time;
  },
  getEndTime: (state) => {
    return state.end_time;
  },
  getMyPoints: (state) => {
    return state.my_points;
  },
  getFPS: (state) => {
    return state.fps;
  },
  getPause: (state) => {
    return state.is_pause;
  },
  getBufferedPercent: (state) => {
    return state.buffered_percent;
  },
  getIsWaitingBuffered: (state) => {
    return state.is_waiting_buffered;
  },
  getVesselMapObjects: (state) => {
    return state.vesselMapObjects;
  },
  getStartPointVessels: (state) => {
    let startPointVessels = [];
    Object.keys(state.vesselMapObjects).forEach((key) => {
      if (
        state.vesselMapObjects[key].pointsArray[0].epoch === state.current_time
      ) {
        startPointVessels.push(state.vesselMapObjects[key]);
      }
    });
    return startPointVessels;
  },
  getStartPointGeoJson: (state) => () => {
    return state.startPointGeoJson;
  },
  getMyTracks: (state) => () => {
    return state.myTracks;
  },
};
